module.exports = __webpack_public_path__ + "img/ESTABA.5df6e6b2.png";